// Import React
import React from "react";

// Import components
import HelpButton from "global/components/HelpButton";

// This renders the grouped toolbar above the product cards
export default function PricingToolbar({
    searchValue,
    onSearchChange,
    comparisonPlans = [],
    comparisonLevels = [],
    currentSubscriptionLevel,
    onToggleComparisonLevel,
    selectedSort,
    onSortChange,
    showIncludingTax,
    onToggleTaxMode,
}) {

    // Render toolbar
    return (
        <section className="pod-pricing-page__products-panel-header">

            {/* This is the toolbar body */}
            <div className="pod-pricing-page__toolbar">

                {/* This is the search control */}
                <div className="pod-pricing-page__toolbar-group pod-pricing-page__toolbar-group--search">
                    <label className="pod-pricing-page__label" htmlFor="pod-pricing-search">Search products</label>
                    <input
                        id="pod-pricing-search"
                        className="pod-pricing-page__input"
                        type="text"
                        value={searchValue}
                        placeholder="Search by title or SKU"
                        onChange={(event) => onSearchChange(event.target.value)}
                    />
                </div>

                {/* This is the comparison level selector */}
                <div className="pod-pricing-page__toolbar-group pod-pricing-page__toolbar-group--compare">
                    <span className="pod-pricing-page__label">Compare to <HelpButton section="plans" code="pricing-comparisons" label="Pricing Comparisons" /></span>

                    <div className="pod-pricing-page__compare-levels">

                        {comparisonPlans.map((plan) => {

                            // Check if this plan is selected for comparison
                            const isSelected = comparisonLevels.includes(Number(plan?.level));

                            // Check if this is the user's current subscription
                            const isCurrent = Number(plan?.level) === Number(currentSubscriptionLevel);

                            // Return one comparison toggle
                            return (

                                <button
                                    key={`compare-${plan?.level}`}
                                    type="button"
                                    className={`pod-pricing-page__compare-button ${isSelected ? "pod-pricing-page__compare-button--active" : ""} ${isCurrent ? "pod-pricing-page__compare-button--current" : ""}`}
                                    disabled={isCurrent}
                                    onClick={() => onToggleComparisonLevel(plan?.level)}
                                >
                                    {plan?.name}
                                </button>

                            );

                        })}

                    </div>

                </div>

                {/* This is the sort control */}
                <div className="pod-pricing-page__toolbar-group">
                    <label className="pod-pricing-page__label" htmlFor="pod-pricing-sort">Sort by</label>
                    <select
                        id="pod-pricing-sort"
                        className="pod-pricing-page__select"
                        value={selectedSort}
                        onChange={(event) => onSortChange(event.target.value)}
                    >
                        <option value="title-asc">Title A-Z</option>
                        <option value="title-desc">Title Z-A</option>
                        <option value="base-low-high">Base price low-high</option>
                        <option value="base-high-low">Base price high-low</option>
                        <option value="savings-high-low">Best savings first</option>
                        <option value="print-areas-high-low">Most print areas</option>
                    </select>
                </div>

                {/* This is the tax mode toggle */}
                <div className="pod-pricing-page__toolbar-group">
                    <span className="pod-pricing-page__label">Display mode <HelpButton section="plans" code="tax-display" label="Tax Display" /></span>
                    <div className="pod-pricing-page__segmented-toggle">
                        <button
                            type="button"
                            className={`pod-pricing-page__segmented-button ${!showIncludingTax ? "pod-pricing-page__segmented-button--active" : ""}`}
                            onClick={() => onToggleTaxMode(false)}
                        >
                            Exc Tax
                        </button>
                        <button
                            type="button"
                            className={`pod-pricing-page__segmented-button ${showIncludingTax ? "pod-pricing-page__segmented-button--active" : ""}`}
                            onClick={() => onToggleTaxMode(true)}
                        >
                            Inc Tax
                        </button>
                    </div>
                </div>
                
            </div>

        </section>
    );

}